import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
export default function Footer() {
  return (
    <div className="base">
      <div className="container">
        <div className="col1">
          <h2>All Anime</h2>
          <p>Email:rawatas0901@gmail.com</p>
          <p>Delhi,New Delhi India</p>
          <p>North India</p>
        </div>
        <div className="col2">
          <a href="https://github.com/unreal0901">
            <FontAwesomeIcon icon={["fab", "github"]} /> Github
          </a>
          <a href="https://www.freecodecamp.org/aditya_singh_rawat">
            <FontAwesomeIcon icon={["fab", "free-code-camp"]} /> FreeCodecamp
          </a>
          <a href="https://codepen.io/unreal0901">
            <FontAwesomeIcon icon={["fab", "codepen"]} /> CodePen
          </a>
        </div>
        <div className="col3">
          <h2>API used:-</h2>
          <a href="https://jikan.moe/">Jikan API</a>
          <a href="https://jikan.moe/">My animeList Database</a>
        </div>
      </div>
      <hr />
      <p className="copy">
        Copyright&copy; {new Date().getFullYear()}|All Anime inc.|
      </p>
    </div>
  );
}
